import { cx } from "cva";
import { ArticleAuthorContact } from "~/components/ArticleAuthorContact";

export type ArticleAuthorStackProps = {
  children: React.ReactNode;
  /** additional class name to be passed to the container */
  className?: string;
};

/** List of author items to be displayed at the bottom of the article page
 *
 * The entire container has a border with radius, and each item fills in a top-border to separate each item.
 */
export const ArticleAuthorStack: React.FC<ArticleAuthorStackProps> = ({
  children,
  className,
}) => (
  <div
    className={cx(
      className,
      "rounded-3 border-1 border-gray-300 [&>*:not(:first-child)]:border-t-1 [&>*]:border-gray-300"
    )}
  >
    {children}
    <ArticleAuthorContact />
  </div>
);
